<template>
    <div class="nopads">
        <!-- Header of collapsable item -->
        <div class="col-12 d-flex justify-content-between align-items-center pb-1">
            <div class="flex-grow-1">
                <h4 class="form-header pointer hover-header" @click.stop="reportsVisible = !reportsVisible">
                    {{ $t('work_report.materials') }}
                </h4>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner-section"
            />
            <div v-else class="ms-2 px-2" @click.stop="reportsVisible = !reportsVisible">
                <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:reportsVisible }"/>
            </div>
        </div>
        <!-- Collapsable content -->
        <div class="routa-collapse" :class="{ collapsed: reportsVisible }">
            <!-- Summary -->
            <div class="col-12 text-center my-2">
                <contract-material-summary
                    :results="materialReports"
                    :attribute="materialReportUnitString.ROAD_NUM"
                    :hide-buttons="true"
                    @emitShowAddMaterialReport="showAddMaterialReportModal"
                    @emitDownloadMaterialReportExcel="downloadMaterialReportExcel"
                />
            </div>

            <manual-material-report-details :results="materialReports" class="my-2"/>
            <span class="span-header my-1">
              {{ $t('work_report.work_team') }}
            </span>
            <team-report-details :results="team"/>
        </div>
        <hr class="report-divider nopads"/>
    </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import ManualMaterialReportDetails from "@/components/contractreport/ManualMaterialReportDetails";
import TeamReportDetails from "@/components/contractreport/TeamReportDetails";
import ContractMaterialSummary from "@/components/contractreport/ContractMaterialSummary.vue";
import {materialReportHelper, materialReportUnitString} from "@/components/mixins/MaterialReportMixin";

export default {
    name: "contract-work-reports",
    computed: {
        materialReportUnitString() {
            return materialReportUnitString
        }
    },
    mixins: [timeUtils, restApi, materialReportHelper],
    components: {ContractMaterialSummary, TeamReportDetails, ManualMaterialReportDetails},
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        }
    },
    data: function () {
        return {
            loading: false,
            results: [],
            materialReports: [],
            team: [],
            reportsVisible: false,
            teamsVisible: false
        }
    },
    mounted() {
        this.fetchWorkReports()
    },
    methods: {
        fetchWorkReports: function () {
            this.results = []
            this.materialReports = []
            this.team = []
            if (this.searchParams) {
                let mappedParams = {
                    contract: this.searchParams.contract,
                    startTime: this.searchParams.dateFrom ? this.getDateIsoString(new Date(this.searchParams.dateFrom)) : null,
                    endTime: this.searchParams.dateTo ? this.getDateIsoString(new Date(this.searchParams.dateTo)) : null,
                }
                this.loading = true
                this.$emit('loading', true)
                this.restFetchParams(this.workReportUrl, mappedParams, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response && response.data) {
                this.results = response.data
                this.extractTeams();
                this.extractManualMaterials()
            }
            this.loading = false
            this.$emit('loading', false)
        },
        extractManualMaterials() {
            this.results.forEach(report => {
                if (report.material_reports) {
                    report.material_reports.forEach(item => this.materialReports.push(item))
                }
            })
        },
        extractTeams() {
            this.results.forEach(report => {
                if (report.persons) {
                    report.persons.forEach(person => {
                        if (!this.personInTeam(person)) {
                            this.team.push(person)
                        }
                    })
                }
            })
        },
        personInTeam(person) {
            return this.team.find(item => item.id === person.id) !== undefined
        },
        downloadMaterialReportExcel: function () {
            // MAYBE TODO ?
        },
        showAddMaterialReportModal() {
            // MAYBE TODO ?
        }
    }
}
</script>
